type HorizontalRowProps = {
  className?: string;
};

/**
 * Renders a horizontal row element in an article.
 * This component returns <hr /> element class name passed.
 */
const HorizontalRow = ({
  className,
}: HorizontalRowProps): React.ReactElement => {
  return (
    <hr className={className} data-testid="article-horizontal-row-component" />
  );
};

export default HorizontalRow;
